import React from "react"

function NHSLogo({width, height, fill, className}) {
    return (
        <svg width={width || 76} height={height || 28} className={className} viewBox="0 0 76 28">
            <title>{"NHS"}</title>
            <g fill={fill || "fff"} fillRule="nonzero">
                <path d="M5.895.981h8.808l5.407 18.297h.075L23.89.981h6.656L24.949 27.37h-8.772l-5.52-18.261h-.075l-3.666 18.26H.26M33.148.981h7.07l-2.08 10.094h8.356L48.573.981h7.069L50.16 27.37h-7.07l2.345-11.305h-8.357L34.737 27.37h-7.071M74.241 6.954c-1.361-.642-3.214-1.21-5.823-1.21-2.796 0-5.063.417-5.063 2.533 0 3.743 10.243 2.343 10.243 10.36 0 7.296-6.766 9.186-12.891 9.186-2.723 0-5.86-.643-8.167-1.362l1.666-5.366c1.399.906 4.195 1.511 6.5 1.511 2.194 0 5.635-.416 5.635-3.138 0-4.235-10.247-2.647-10.247-10.095 0-6.804 5.974-8.846 11.757-8.846 3.253 0 6.316.339 8.091 1.172" />
            </g>
        </svg>
    )
}

export default NHSLogo
